(function () {
  class WinningsText extends PIXI.Container {
    constructor() {
      super();

      Reflex.registerEventHandler('ready', this.onReady.bind(this));
    }

    onReady = function () {
      this._container = resourceManager.get(this.name + ':winningsTextContainer');
      this._mainText = resourceManager.get(
        this.name + ':winningsTextContainer:winningsTextScaleContainer:winningsText'
      );
      this._mainTextScaleContainer = resourceManager.get(
        this.name + ':winningsTextContainer:winningsTextScaleContainer'
      );
      this._mainText.setText('1');
      this._mainTextScaleContainer.pivot.set(this._mainText.Props.maxWidth / 2, this._mainText.height / 2);
      this._mainText.setText('');
      this._blackMask = resourceManager.get(this.name + ':winningsTextContainer:blackmask');

      this._multiplierTextContainer = resourceManager.get(this.name + ':multiplierTextContainer');
      this._multiplier = resourceManager.get(this.name + ':multiplierTextContainer:multiplierText');
      this._multiplierBlackMask = resourceManager.get(this.name + ':multiplierTextContainer:blackmask');

      this._multiplierTextContainer.visible = false;
      this._currentMultiplierScale = 0;

      this._multiplierPositionX = this._multiplierTextContainer.x;
      this._multiplierPositionY = this._multiplierTextContainer.y;

      this._sparksAnim = resourceManager.get(this.name + ':sparksAnim');

      this.setGlow(0);
      this.show(false);
    };

    onOrientationChange() {
      if (this._currentMultiplierScale) {
        this.setMultiplierScale(this._currentMultiplierScale);
      }
    }

    setText = function (value) {
      var valueText = gdk.formatCurrency(value);
      this._mainText.setText(valueText);
      this._blackMask.width = this._mainText.width * 0.9;
      this._blackMask.height = this._mainText.height * 1.1;
    };

    show = function (show, value, animate) {
      if (animate === true && show === false) {
        this.scaleDown();
      } else {
        this.visible = show;
        this.alpha = 1;
        this.setScale(1);
        if (value) {
          this.setText(value);
        }
      }
    };

    setGlow = function (alpha) {
      // this._highlight.visible = (alpha > 0);
      // this._highlight.alpha = alpha;
    };

    setScale = function (scale) {
      this.scale.set(scale);
    };

    setMultiplier = function (multiplier) {
      if (multiplier > 0) this._multiplier.alpha = 1;
      this._multiplier.setText('X' + multiplier);
      this._multiplierBlackMask.width = this._multiplier.width * 2;
      this._multiplierBlackMask.height = this._multiplier.height * 2;
    };

    setMultiplierScale = function (scale) {
      var containerBaseY = this._container.Props[layoutController.getCurrentLayout()].position.y;

      this._container.position.setY(containerBaseY - Math.sin(Math.PI * 0.5 * scale) * 50);
      this._multiplierTextContainer.visible = scale > 0;
      this._multiplierTextContainer.scale.set(scale * 1);
      this._currentMultiplierScale = scale;
    };

    resetMultiplierPosition() {
      this.onOrientationChange();

      this._multiplierTextContainer.position.x = this._multiplierPositionX;
      this._multiplierTextContainer.position.y = this._multiplierPositionY;
    }

    moveMultiplier(winnings, skip) {
      this.movingMuliplier = true;
      if (skip) {
        this.setMultiplierScale(0);
        this.setText(winnings);
      } else {
        var moveAmount = 125;
        var targetY = this._multiplierTextContainer.position.y - moveAmount;

        gsap.delayedCall(0.3, () => {
          soundManager.play('winMultiplierApply');
        });

        this.moveTween = gsap.to(this._multiplierTextContainer, {
          duration: 0.5,
          y: targetY,
          onUpdate: () => {
            let progress = this.moveTween.progress();
            var containerBaseY = this._container.Props[layoutController.getCurrentLayout()].position.y;
            this._container.position.setY(containerBaseY - Math.sin(Math.PI * 0.5 * (1 - progress)) * 50);
          },
          onComplete: () => {
            this.setMultiplierScale(0);

            this._multiplierTextContainer.position.y = targetY + moveAmount;

            this._sparksAnim.visible = true;
            this._sparksAnim.gotoAndPlay(0);

            gsap.delayedCall(1, () => {
              this._sparksAnim.visible = false;
            });

            this.movingMuliplier = false;
          },
          ease: 'back.in(4)',
        });
      }
    }

    async animateForBigWin() {
      // move down this._container
      // also scale it up

      this._container.origY = this._container.y;

      await Promise.all([
        Utils.tweenFromToAsync(
          this._container,
          {
            y: this._container.y,
          },
          {
            y: this._container.y + 100,
            duration: 0.5,
          }
        ),
        Utils.tweenFromToAsync(
          this._container.scale,
          {
            x: 1,
            y: 1,
          },
          {
            x: 1.3,
            y: 1.3,
            duration: 0.5,
          }
        ),
      ]);

      this.pulse();
    }

    async restoreAfterBigWin() {
      this.stopPulsing();

      await Promise.all([
        Utils.tweenFromToAsync(
          this._container,
          {
            y: this._container.y,
          },
          {
            y: this._container.y - 100,
            duration: 0.5,
          }
        ),
        Utils.tweenFromToAsync(
          this._container.scale,
          {
            x: this._container.scale.x,
            y: this._container.scale.y,
          },
          {
            x: 1,
            y: 1,
            duration: 0.5,
          }
        ),
      ]);
    }

    pulse(scaleFrom = 1.3, scaleTo = 1.4, duration = 0.15, repeat = -1) {
      this.pulseTween = gsap.fromTo(
        this._container.scale,
        {
          x: scaleFrom,
          y: scaleFrom,
        },
        {
          x: scaleTo,
          y: scaleTo,
          duration: duration,
          repeat: repeat,
          yoyo: true,
        }
      );
    }

    stopPulsing() {
      this.pulseTween.kill();
    }

    scaleDown(value) {
      this._container.origScale = this._container.scale.x;
      gsap.fromTo(
        this._container,
        {
          pixi: {
            scale: this._container.scale.x,
            alpha: 1,
          },
        },
        {
          pixi: {
            scale: 0,
            alpha: 0,
          },
          duration: 0.5,
          ease: 'back.in',
          onComplete: () => {
            this.show(false, value, false);
            this._container.alpha = 1;
            this._container.scale.set(this._container.origScale);
          },
        }
      );
    }
  }

  let winningsTextCreator = function (json) {
    return new WinningsText();
  };

  resourceManager.registerObjectType(
    'winningsText',
    winningsTextCreator,
    function () {},
    function () {
      return [];
    }
  );
})();
